import { render, staticRenderFns } from "./Hints.vue?vue&type=template&id=40af713e&scoped=true&"
import script from "./Hints.vue?vue&type=script&lang=js&"
export * from "./Hints.vue?vue&type=script&lang=js&"
import style0 from "./Hints.vue?vue&type=style&index=0&id=40af713e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40af713e",
  null
  
)

export default component.exports